import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Heading as Heading$1, CustomPropTypes } from '@zillow/zrs-cms';
import PropTypes from 'prop-types';
import React from 'react';
import { usePlacement } from '../../components/PlacementProvider/PlacementProvider.js';
import makeContentInteractive from '../../util/makeSpansInteractive.js';

var _excluded = ["content", "textAlign", "level", "margin"];
var BlockHeading = function BlockHeading(_ref) {
  var attrs = _ref.attrs;
  var content = attrs.content,
    _attrs$textAlign = attrs.textAlign,
    textAlign = _attrs$textAlign === void 0 ? 'inherit' : _attrs$textAlign,
    level = attrs.level,
    margin = attrs.margin,
    rest = _objectWithoutProperties(attrs, _excluded);
  var interactiveContent = makeContentInteractive(content);
  var attributes = Object.assign({
    as: 'h2',
    fontType: {
      default: 'h2'
    },
    fontFamily: 'sansSerif',
    marginBottom: 'sm',
    fontColor: '',
    textAlign: textAlign
  }, rest);

  // Backward compat.
  if (level && !attrs.fontType) {
    attributes.fontType = "h" + level;
  }

  // Create responsive mappings.
  if (typeof attributes.fontType === 'string') {
    var mappings = {
      h0: {
        default: 'h0',
        sm_lte: 'h2'
      },
      h1: {
        default: 'h1',
        sm_lte: 'h2'
      },
      h2: {
        default: 'h2',
        sm_lte: 'h3'
      },
      h3: {
        default: 'h3'
      },
      h4: {
        default: 'h4'
      },
      h5: {
        default: 'h5'
      },
      h6: {
        default: 'h6'
      }
    };
    if (!attrs.as) {
      attributes.as = attributes.fontType;
    }
    attributes.fontType = mappings[attributes.fontType];
  }
  return /*#__PURE__*/React.createElement(Heading$1, _extends({
    placement: usePlacement()
  }, attributes, margin), interactiveContent);
};
BlockHeading.propTypes = process.env.NODE_ENV !== "production" ? {
  attrs: PropTypes.shape({
    as: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
    fontType: CustomPropTypes.inlineMediaQuery(PropTypes.string),
    content: PropTypes.string,
    textAlign: PropTypes.string,
    margin: CustomPropTypes.inlineMediaQuery(PropTypes.shape({
      marginTop: PropTypes.string,
      marginBottom: PropTypes.string
    }))
  }),
  index: PropTypes.number
} : {};
var Heading = BlockHeading;

export { Heading as default };
